import type { AdminDebugSubscription200Data } from './adminDebugSubscription200Data';

export type AdminDebugSubscription200 = {
  data?: AdminDebugSubscription200Data;
  message?: string;
  success?: boolean;
};
